"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePassword = changePassword;
var _action_types = require("../../constants/action_types");
function changePassword(password) {
  return {
    type: _action_types.AUTHENTICATION_CHANGE_PASSWORD_TYPE,
    password
  };
}